import { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { Search, X } from "lucide-react";
import { useStore } from "@/store/StoreContext";
import { formatIDR } from "@/lib/format";
import { useProducts } from "@/hooks/useProducts";

export const SearchOverlay = () => {
  const { searchOpen, setSearchOpen } = useStore();
  const [term, setTerm] = useState("");
  const { data: products = [] } = useProducts();

  useEffect(() => {
    if (!searchOpen) setTerm("");
  }, [searchOpen]);

  const results = useMemo(() => {
    const t = term.trim().toLowerCase();
    if (!t) return [];
    return products.filter(
      (p) =>
        p.name.toLowerCase().includes(t) ||
        p.color.toLowerCase().includes(t) ||
        p.collection_name.toLowerCase().includes(t)
    );
  }, [term, products]);

  if (!searchOpen) return null;

  return (
    <div className="fixed inset-0 z-50 bg-paper" data-testid="search-overlay">
      <div className="mx-auto max-w-[900px] px-5 pt-10 md:px-10 md:pt-20">
        <div className="flex items-center justify-between">
          <p className="label-eyebrow text-sand">Cari Produk</p>
          <button
            onClick={() => setSearchOpen(false)}
            className="p-2 text-ink"
            aria-label="Tutup pencarian"
            data-testid="search-close-button"
          >
            <X size={20} />
          </button>
        </div>

        <div className="mt-8 flex items-center gap-4 border-b border-ink pb-4">
          <Search size={22} strokeWidth={1.5} className="text-stone" />
          <input
            autoFocus
            value={term}
            onChange={(e) => setTerm(e.target.value)}
            placeholder="Ketik nama atau warna gelang…"
            className="w-full bg-transparent font-display text-2xl text-ink outline-none placeholder:text-stone/60 md:text-4xl"
            data-testid="search-input"
          />
        </div>

        <div className="mt-10 max-h-[55vh] overflow-y-auto" data-testid="search-results">
          {results.map((p) => (
            <Link
              key={p.slug}
              to={`/produk/${p.slug}`}
              onClick={() => setSearchOpen(false)}
              className="flex items-center gap-5 border-b border-line py-4 transition-colors duration-300 hover:bg-linen"
              data-testid={`search-result-${p.slug}`}
            >
              <img src={p.images?.[0]} alt={p.name} className="h-16 w-16 object-cover" />
              <div className="flex-1">
                <p className="font-display text-lg text-ink">{p.name}</p>
                <p className="text-xs text-stone">{p.color}</p>
              </div>
              <p className="text-sm text-ink">{formatIDR(p.price)}</p>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
};
